<form [formGroup]="form" class="etapa-form" (ngSubmit)="salvar()">
  <div class="n-container-orientacoes">
    <h4 class="n-titulo-orientacao">{{ 'PRIMEIRO_ACESSO.SERVICOS.ORIENTACAO_TITULO' | translate }}</h4>
    <p>{{ 'PRIMEIRO_ACESSO.SERVICOS.ORIENTACAO_TEXTO' | translate }}</p>
  </div>

  <div class="n-servicos-layout">
    <!-- Formulário de Serviço -->
    <div class="n-servico-form">
      <div class="n-form-section">
        <h4 class="n-section-title">{{ 'PRIMEIRO_ACESSO.SERVICOS.NOVO_SERVICO' | translate }}</h4>

        <div class="n-field-group">
          <div class="n-field n-field-large">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.SERVICOS.LABEL_NOME' | translate"
              controlName="nome"
              [required]="true"
              [maxLength]="50"
            >
              <input
                pInputText
                id="nome"
                formControlName="nome"
                [placeholder]="'PRIMEIRO_ACESSO.SERVICOS.PLACEHOLDER_NOME' | translate"
                maxlength="50"
              />
            </lib-form-field>
          </div>

          <div class="n-field n-field-large">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.SERVICOS.LABEL_CATEGORIA' | translate"
              controlName="tipoServicoId"
              [required]="true"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                formControlName="tipoServicoId"
                [options]="$tiposServico()"
                optionLabel="nome"
                optionValue="id"
                [placeholder]="'PRIMEIRO_ACESSO.SERVICOS.PLACEHOLDER_CATEGORIA' | translate"
              />
              } @else {
              <p-select
                id="tipoServicoId"
                formControlName="tipoServicoId"
                [options]="$tiposServico()"
                optionLabel="nome"
                optionValue="id"
                [placeholder]="'PRIMEIRO_ACESSO.SERVICOS.PLACEHOLDER_CATEGORIA' | translate"
                [emptyMessage]="'PRIMEIRO_ACESSO.SERVICOS.NENHUM_RESULTADO' | translate"
              />
              }
            </lib-form-field>
          </div>
        </div>

        <div class="n-field-group">
          <div class="n-field">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.SERVICOS.LABEL_DURACAO' | translate"
              controlName="duracaoTime"
              [required]="true"
              [helpText]="'PRIMEIRO_ACESSO.SERVICOS.MAXIMO' | translate: { maximo: formatarDuracaoExibicao(duracaoMaximaMinutos()) }"
            >
              <p-datepicker
                id="duracaoTime"
                formControlName="duracaoTime"
                [showIcon]="true"
                [timeOnly]="true"
                [showTime]="true"
                [readonlyInput]="true"
                [iconDisplay]="'input'"
                hourFormat="24"
                stepMinute="5"
                [maxDate]="duracaoMaximaDate()"
                placeholder="00:30"
                appendTo="body"
              />
            </lib-form-field>
          </div>

          <div class="n-field">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.SERVICOS.LABEL_VALOR' | translate"
              controlName="valor"
              [required]="false"
            >
              <p-inputGroup>
                <p-inputGroupAddon>{{ simboloMoeda() }}</p-inputGroupAddon>
                <p-inputNumber
                  id="valor"
                  formControlName="valor"
                  placeholder="0,00"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                />
              </p-inputGroup>
            </lib-form-field>
          </div>
        </div>

        <div class="n-add-action">
          <p-button
            [label]="'PRIMEIRO_ACESSO.SERVICOS.BOTAO_ADICIONAR' | translate"
            (onClick)="adicionarServico()"
            styleClass="n-button-sec"
            icon="pi pi-plus"
            type="button"
            [loading]="$loading()"
            [fluid]="true"
          />
        </div>
      </div>
    </div>

    <!-- Lista de Serviços -->
    @if (servicosSignal().length > 0) {
    <div class="n-servicos-lista">
      <h4 class="n-section-title">
        {{ 'PRIMEIRO_ACESSO.SERVICOS.SERVICOS_CADASTRADOS' | translate: { total: servicosSignal().length } }}
      </h4>
      <div class="n-servicos-cards">
        @for (servico of servicosSignal(); track $index) {
        <div class="n-servico-card">
          <div class="n-servico-info">
            <h5>{{ servico.nome }}</h5>
            <p class="n-servico-tipo">
              {{ nomeTipoServico(servico.tipoServicoId!) }}
            </p>
            <div class="n-servico-details">
              <span class="n-duration">⏱️ {{ servico.duracao }} min</span>
              <span class="n-price"
                >💰
                {{
                  servico.valor || 0 | moeda
                }}</span
              >
            </div>
          </div>
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            severity="danger"
            (click)="removerServico($index)"
            class="n-remove-btn"
            size="small"
          >
            {{ 'PRIMEIRO_ACESSO.SERVICOS.REMOVER' | translate }}
          </button>
        </div>
        }
      </div>
    </div>
    }
  </div>
</form>

<ng-template #headerTemplate>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            <i class="pi pi-list mr-2"></i>
            {{ 'PRIMEIRO_ACESSO.SERVICOS.HEADER_TITULO' | translate }}
          </span>
        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fechar.emit()"
            [attr.aria-label]="'GLOBAL.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex gap-2 justify-content-end w-full">
    <p-button
      [label]="'GLOBAL.VOLTAR' | translate"
      icon="pi pi-arrow-left"
      (onClick)="voltar()"
      [loading]="$loading()"
      severity="secondary"
      [outlined]="true"
      type="button"
    />
    <p-button
      type="button"
      [label]="'GLOBAL.PROXIMO' | translate"
      styleClass="p-button-primary"
      iconPos="right"
      icon="pi pi-arrow-right"
      [loading]="$loading()"
      [disabled]="servicosSignal().length === 0 || $loading()"
      (onClick)="salvar()"
    />
  </div>
</ng-template>
